import React, { useState, useEffect } from "react";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { getToken } from "../../../../helpers/Jwt";
import CurrencyInput from "../../../../helpers/CurrencyInput";
import InputOption from "../../component/InputOption/InputOption";

const EntryProduct = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [initialValues, setInitialValues] = useState({
        name: '',
        unit: '',
        category: '',
        price_buy: '',
        price_sell: '',
        account_id_buy: '',
        tax_account_id_buy: '',
        account_id_sell: '',
        tax_account_id_sell: '',
        monitoring_stock: '',
        account_id_monitoring_stock: ''
    });

    const [showBuyProductLayout, setShowBuyProductLayout] = useState(false);
    const [showSellProductLayout, setShowSellProductLayout] = useState(false);
    const [showStockMonitoringLayout, setShowStockMonitoringLayout] = useState(true);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Nama Produk is wajib diisi.'),
        unit: Yup.string().required('Satuan Produk is wajib diisi.'),
        // category: Yup.string().required('Kategori Produk is wajib diisi.')
    });

    const [loadingCategories, setLoadingCategories] = useState(false);
    const [categories, setCategories] = useState([]);

    const [loadingAccountProductBuy, setLoadingAccountProductBuy] = useState(false);
    const [accountProductBuy, setAccountProductBuy] = useState([]);

    const [loadingAccountProductSell, setLoadingAccountProductSell] = useState(false);
    const [accountProductSell, setAccountProductSell] = useState([]);

    const [loadingAccountStockMonitoring, setLoadingAccountStockMonitoring] = useState(false);
    const [accountStockMonitoring, setAccountStockMonitoring] = useState([]);

    const [loadingAccountTax, setLoadingAccountTax] = useState(false);
    const [accountTax, setAccountTax] = useState([]);

    const [errorCategories, setErrorCategories] = useState(false);

    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_PRODUCT = "api/erpppsu/product";
    const PATH_EXPENSE_PRTY_PRODUCT_BUY = "api/erpppsu/account/expense?priority=product-buy";
    const PATH_EXPENSE_PRTY_PRODUCT_SELL = "api/erpppsu/account/expense?priority=product-sell";
    const PATH_EXPENSE_PRTY_INVENTORY = "api/erpppsu/account/expense?priority=inventory";
    const PATH_ACCOUNT_TAX = "api/erpppsu/account/taxes";

    // Fetch data from the API
    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
        }
    };

    useEffect(() => {
        if (id) {
            fetchData(`${BASE_URL}${PATH_PRODUCT}/detail?id=${id}`,).then((product) => {
                if (product) {

                    if (product?.price_buy !== null && product?.price_buy !== "") {
                        setShowBuyProductLayout(true);
                    }

                    // Check if price_sell is not null or empty string
                    if (product?.price_sell !== null && product?.price_sell !== "") {
                        setShowSellProductLayout(true);
                    }

                    setInitialValues({
                        code: product.code || '',
                        name: product.name || '',
                        unit: product.unit || '',
                        category: product.category || '',
                        price_buy: product.price_buy || '',
                        price_sell: product.price_sell || '',
                        description: product.description || '',
                        account_id_buy: product.account_id_buy || '',
                        tax_account_id_buy: product.tax_account_id_buy || '',
                        account_id_sell: product.account_id_sell || '',
                        tax_account_id_sell: product.tax_account_id_sell || '',
                        monitoring_stock: product.monitoring_stock || '',
                        account_id_monitoring_stock: product.account_id_monitoring_stock || ''
                    });
                }
            });
        }
    }, [id]);

    useEffect(() => {
        setLoadingCategories(true);
        setLoadingAccountProductBuy(true);
        setLoadingAccountProductSell(true);
        setLoadingAccountStockMonitoring(true);
        setLoadingAccountTax(true);

        fetchData(`${BASE_URL}${PATH_PRODUCT}/categories`,).then((data) => {
            setCategories(data);
        }).finally(() => {
            setLoadingCategories(false);
        });

        fetchData(`${BASE_URL}${PATH_EXPENSE_PRTY_PRODUCT_BUY}`,).then((data) => {
            setAccountProductBuy(data);
        }).finally(() => {
            setLoadingAccountProductBuy(false);
        });

        fetchData(`${BASE_URL}${PATH_EXPENSE_PRTY_PRODUCT_SELL}`,).then((data) => {
            setAccountProductSell(data);
        }).finally(() => {
            setLoadingAccountProductSell(false);
        });

        fetchData(`${BASE_URL}${PATH_EXPENSE_PRTY_INVENTORY}`,).then((data) => {
            setAccountStockMonitoring(data);
        }).finally(() => {
            setLoadingAccountStockMonitoring(false);
        });

        fetchData(`${BASE_URL}${PATH_ACCOUNT_TAX}`,).then((data) => {
            setAccountTax(data);
        }).finally(() => {
            setLoadingAccountTax(false);
        });
    }, []);

    const onSubmit = async (values, requests) => {
        try {
            const payload = {
                id,
                ...values,
            };

            await axios.post(`${BASE_URL}${PATH_PRODUCT}`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getToken()}`
                }
            });

            navigate('/activity-erpppsu/product');
        } catch (error) {
            alert(error);
            console.error('Error submitting form:', error);
        } finally {
            requests.setSubmitting(false);
        }
    };

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="mx-auto p-4">
            <h2 className="text-2xl font-bold mb-4">
                {id ? `Edit Produk` : 'Tambah Produk'}
            </h2>

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <Form onSubmit={handleSubmit}>
                        <div className="gap-4 px-4 py-2">
                            <label htmlFor="name">Nama Produk</label>
                            <Field
                                className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                name="name" />
                            <ErrorMessage name="name" component="p" className='text-red-500 text-xs mt-1' />
                        </div>
                        <div className="gap-4 px-4 py-2">
                            <label htmlFor="unit">Satuan Produk</label>
                            <Field
                                className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                name="unit" />
                            <ErrorMessage name="unit" component="p" className='text-red-500 text-xs mt-1' />
                        </div>
                        <div className="gap-4 px-4 py-2">
                            <label htmlFor="category">Kategori Produk</label>
                            {loadingCategories ? (
                                <h1>Loading...</h1>
                            ) : (
                                <InputOption
                                    label="Pilih Kategori"
                                    data={categories}
                                    placeholder="Pilih Kategori"
                                    defaultValue={values?.category}
                                    onChange={(value) => {
                                        setFieldValue('category', value)
                                    }}
                                />
                            )}
                            <ErrorMessage name="category" component="p" className='text-red-500 text-xs mt-1' />
                        </div>

                        <div className="gap-4 px-4 py-2">
                            <label htmlFor="description">Deksripsi Produk</label>
                            <Field
                                as="textarea"
                                name="description"
                                placeholder="Deskripsi"
                                className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                columns={3} />
                            <ErrorMessage name="category" component="p" className='text-red-500 text-xs mt-1' />
                        </div>

                        <div className="p-6">
                            <div className="border-b pb-4 mb-4">
                                <h2 className="text-lg font-semibold text-gray-800">Harga & Persediaan</h2>
                            </div>
                            <form className="space-y-6">
                                <div className="border-b pb-4 mb-4">
                                    <label className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            className="w-4 h-4 text-blue-600 border-gray-300 rounded"
                                            checked={showBuyProductLayout}
                                            onChange={() => setShowBuyProductLayout(!showBuyProductLayout)}
                                        />
                                        <span className="text-gray-800">Saya beli produk ini</span>
                                    </label>

                                    {showBuyProductLayout && (
                                        <div className="mt-4 space-y-2">
                                            <div>
                                                <label className="block text-sm text-gray-600">Harga beli satuan</label>
                                                <CurrencyInput
                                                    id="price_buy"
                                                    name="price_buy"
                                                    currency="IDR"
                                                    placeholder="Masukkan Nominal"
                                                    value={values.price_buy}
                                                    onChange={(value) => setFieldValue('price_buy', value)}
                                                    className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                                />
                                            </div>
                                            <div className="flex space-x-4">
                                                <div className="flex-1">
                                                    <label className="block text-sm text-gray-600">Akun pembelian</label>
                                                    {loadingAccountProductBuy ? (
                                                        <h1>Loading...</h1>
                                                    ) : (
                                                        <InputOption
                                                            label="Pilih Akun"
                                                            data={accountProductBuy}
                                                            placeholder="Cari disini"
                                                            defaultValue={values?.account_id_buy}
                                                            onChange={(value) => {
                                                                setFieldValue('account_id_buy', value)
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                                <div className="flex-1">
                                                    <label className="block text-sm text-gray-600">Pajak beli</label>
                                                    {loadingAccountTax ? (
                                                        <h1>Loading...</h1>
                                                    ) : (
                                                        <InputOption
                                                            label="Pilih Pajak"
                                                            data={accountTax}
                                                            placeholder="Cari disini"
                                                            defaultValue={values?.tax_account_id_buy}
                                                            onChange={(value) => {
                                                                setFieldValue('tax_account_id_buy', value)
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Section: Saya Jual Produk Ini */}
                                <div className="border-b pb-4 mb-4">
                                    <label className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            className="w-4 h-4 text-blue-600 border-gray-300 rounded"
                                            checked={showSellProductLayout}
                                            onChange={() => setShowSellProductLayout(!showSellProductLayout)}
                                        />
                                        <span className="text-gray-800">Saya jual produk ini</span>
                                    </label>
                                    {showSellProductLayout && (
                                        <div className="mt-4 space-y-2">
                                            <div>
                                                <label className="block text-sm text-gray-600">Harga jual satuan</label>
                                                <CurrencyInput
                                                    id="price_sell"
                                                    name="price_sell"
                                                    currency="IDR"
                                                    placeholder="Masukkan Nominal"
                                                    value={values.price_sell}
                                                    onChange={(value) => setFieldValue('price_sell', value)}
                                                    className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                                />
                                            </div>
                                            <div className="flex space-x-4">
                                                <div className="flex-1">
                                                    <label className="block text-sm text-gray-600">Akun penjualan</label>
                                                    {loadingAccountProductSell ? (
                                                        <h1>Loading...</h1>
                                                    ) : (
                                                        <InputOption
                                                            label="Pilih Akun"
                                                            data={accountProductSell}
                                                            placeholder="Cari disini"
                                                            defaultValue={values?.account_id_sell}
                                                            onChange={(value) => {
                                                                setFieldValue('account_id_sell', value)
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                                <div className="flex-1">
                                                    <label className="block text-sm text-gray-600">Pajak jual</label>
                                                    {loadingAccountTax ? (
                                                        <h1>Loading...</h1>
                                                    ) : (
                                                        <InputOption
                                                            label="Pilih Pajak"
                                                            data={accountTax}
                                                            placeholder="Cari disini"
                                                            defaultValue={values?.tax_account_id_sell}
                                                            onChange={(value) => {
                                                                setFieldValue('tax_account_id_sell', value)
                                                            }}
                                                        />)}
                                                </div>
                                            </div>
                                            <div className="text-sm text-blue-600">
                                                <a href="#">Butuh akun diskon? Aktifkan sekarang</a>
                                            </div>
                                        </div>)}
                                </div>

                                {/* Section: Monitor Persediaan Barang */}
                                <div className="border-b pb-4 mb-4">
                                    <label className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            className="w-4 h-4 text-blue-600 border-gray-300 rounded"
                                            checked={showStockMonitoringLayout}
                                            onChange={() => setShowStockMonitoringLayout(!showStockMonitoringLayout)}
                                        />
                                        <span className="text-gray-800">Monitor persediaan barang</span>
                                    </label>
                                    {showStockMonitoringLayout && (
                                        <div className="flex space-x-4">
                                            <div className="flex-1">
                                                <label className="block text-sm text-gray-600">Batas stok minimum</label>
                                                <Field
                                                    className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                                    name="monitoring_stock" />
                                            </div>
                                            <div className="flex-1">
                                                <label className="block text-sm text-gray-600">Akun persediaan barang</label>
                                                <InputOption
                                                    label="Pilih Akun"
                                                    data={accountStockMonitoring}
                                                    placeholder="Cari disini"
                                                    defaultValue={values?.account_id_monitoring_stock}
                                                    onChange={(value) => {
                                                        setFieldValue('account_id_monitoring_stock', value)
                                                    }}
                                                />
                                            </div>
                                        </div>)}
                                </div>
                            </form>
                        </div>

                        <div className="m-4">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                                    }`}
                            >
                                {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default EntryProduct;
